// @ts-nocheck

export { connect } from 'dva';
export { getApp as getDvaApp } from './dva';
